import "esbuild-css-modules-plugin-ns-css:src/lib/gantt-task-react/src/components/task-list/task-list-header.module.css";

export default {
  "ganttTable": "task-list-header-module__ganttTable_SBfL1q__100",
  "ganttTableHeader": "task-list-header-module__ganttTable_Header_SBfL1q__100",
  "ganttTableHeaderItem": "task-list-header-module__ganttTable_HeaderItem_SBfL1q__100",
  "ganttTableHeaderSeparator": "task-list-header-module__ganttTable_HeaderSeparator_SBfL1q__100"
};
      